module.exports = __webpack_public_path__ + "img/yaoshiguanlifuwu_image_zy.087ceb25.png";